var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'sj-checkbox',
    ("sj-checkbox-size-" + _vm.size),
    {
      disabled: _vm.disabled
    }
  ],on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_c('div',{staticClass:"sj-checkbox-box",class:[_vm.theme, { checked: _vm.value, indeterminate: _vm.indeterminate }]},[(_vm.indeterminate)?[_c('span',{staticClass:"indeterminate-icon"})]:[(_vm.value)?_c('i',{staticClass:"comcom_check icon_com comcheckbox_check"}):_vm._e()]],2),(_vm.label)?_c('div',{staticClass:"sj-checkbox-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }